export default {"src":"/_next/static/media/iconAdd.a3280d6b.svg","height":40,"width":40};